import type { InicioFunilEtapa, InicioResumoQuery } from '@triade/contracts';

export type PeriodoInicio = InicioResumoQuery['periodo'];

export const PERIODOS: Array<{ valor: PeriodoInicio; rotulo: string }> = [
  { valor: 'mes', rotulo: 'Mês atual' },
  { valor: '30', rotulo: '30 dias' },
  { valor: '90', rotulo: '90 dias' },
];

export const ROTULO_ETAPA: Record<InicioFunilEtapa['status'], string> = {
  RASCUNHO: 'Rascunho',
  ENVIADO: 'Enviado',
  EM_NEGOCIACAO: 'Em negociação',
  APROVADO: 'Aprovado',
};

/** Rotulos de tipo de item (mesmos da tela de cadastro). Chave desconhecida volta crua. */
export const ROTULO_ITEM_TIPO: Record<string, string> = {
  PRODUTO: 'Produto fabricado',
  MERCADORIA: 'Mercadoria',
  SERVICO: 'Serviço',
  SERVICO_TERCEIRO: 'Serviço de terceiro',
  MATERIA_PRIMA: 'Matéria-prima',
  MATERIAL_SECUNDARIO: 'Material secundário',
  EMBALAGEM: 'Embalagem',
  MATERIAL_AUXILIAR: 'Material auxiliar',
};

export const ROTULO_RATEIO_STATUS: Record<string, string> = { ABERTO: 'Aberto', FECHADO: 'Fechado' };

/** AAAA-MM (competencia) para MM/AAAA. Invalido volta cru. */
export function formatarCompetencia(comp: string): string {
  const m = /^(\d{4})-(\d{2})$/.exec(comp);
  return m ? `${m[2]}/${m[1]}` : comp;
}
